import React from 'react';
import { Database, Plus } from 'lucide-react';
import { Glyph, MetaStat, Panel, PrimaryAction, Row, RowText, ScreenHeader } from './ui';

// ── Tables ───────────────────────────────────────────────────────────────────
// Structured data Giga can read and write. Like tracks, every table belongs to a
// group, so access follows the group.
//
// Rebuilt on the shared primitives in ./ui.tsx — the teal-tinted icon square and
// the grid of grey bordered cards are gone. Row size, source and last update now
// sit in aligned columns, because those are the three things you scan a table
// directory to compare. No copy or data changed.
// ─────────────────────────────────────────────────────────────────────────────

const TABLES: {
  name: string;
  group: string;
  rows: number;
  columns: number;
  source: string;
  updated: string;
}[] = [{
  name: 'Customer advocates',
  group: 'Marketing',
  rows: 248,
  columns: 11,
  source: 'Notion',
  updated: '4m ago'
}, {
  name: 'Integration coverage',
  group: 'Product & Engineering',
  rows: 96,
  columns: 8,
  source: 'Giga native',
  updated: '1h ago'
}, {
  name: 'Content calendar',
  group: 'Marketing',
  rows: 132,
  columns: 9,
  source: 'Airtable',
  updated: '2h ago'
}, {
  name: 'Trial signups',
  group: 'Revenue',
  rows: 4216,
  columns: 6,
  source: 'Google Sheets',
  updated: '12m ago'
}, {
  name: 'Ad spend by channel',
  group: 'Marketing',
  rows: 74,
  columns: 12,
  source: 'Google Sheets',
  updated: 'Yesterday'
}, {
  name: 'Automation backlog',
  group: 'Operations',
  rows: 61,
  columns: 7,
  source: 'Giga native',
  updated: '3d ago'
}];
export function TablesView() {
  return <div data-id="element-2949" data-mp="2928lrwvq0y8h">
      <ScreenHeader title="Tables" description="Structured data Giga can read and write — created here or synced from a connected tool. Tables belong to a group, so access follows the group." action={<PrimaryAction label="New table" data-id="element-2951" data-mp="29y3d8joukh9">
            <Plus size={15} data-id="element-2952" data-mp="2azfzhgcrf13" />
            New table
          </PrimaryAction>} data-id="element-2950" data-mp="241awl0can3xh" />

      <Panel className="mt-6" data-id="element-2953" data-mp="1wpmojvqd0wrq">
        {TABLES.map(table => <Row key={table.name} className="flex-wrap gap-y-4 md:flex-nowrap" data-id="element-2954" data-mp="1wo38a54pelpy">
            <Glyph icon={Database} data-id="element-2955" data-mp="21ifu2ltnk94v" />
            <RowText title={table.name} meta={table.group} data-id="element-2956" data-mp="21ipii4z1u88g" />

            <dl className="flex w-full shrink-0 items-start gap-6 md:w-auto md:gap-10" data-id="element-2957" data-mp="1mtjp4xmw7c8h">
              <span className="w-16" data-id="element-2958" data-mp="1rruyz8d6tmqp">
                <MetaStat label="Rows" value={table.rows.toLocaleString('en-US')} data-id="element-2959" data-mp="1roqmzothdmph" />
              </span>
              <span className="w-16" data-id="element-2960" data-mp="2fetea2pkmon1">
                <MetaStat label="Columns" value={table.columns} data-id="element-2961" data-mp="2kg0kvyfz9hs4" />
              </span>
              <span className="w-28" data-id="element-2962" data-mp="25izq1m2hp6pf">
                <MetaStat label="Source" value={<span className="text-[13.5px] font-semibold" data-id="element-2964" data-mp="25kuaz0drgyti">{table.source}</span>} data-id="element-2963" data-mp="25hye7fdngg6n" />
              </span>
              <span className="w-24" data-id="element-2965" data-mp="u3b2otlbq5o3">
                <MetaStat label="Updated" value={<span className="text-[13.5px] font-semibold" data-id="element-2967" data-mp="u200gy7j15z3">{table.updated}</span>} data-id="element-2966" data-mp="u29qumwhhf5b" />
              </span>
            </dl>
          </Row>)}
      </Panel>
    </div>;
}